import type { Image } from '@content-scheduler/shared/render';
import styles from './parts.module.css';

export function Media({ image, className }: { image: Image; className?: string }) {
    if (!image?.src.trim()) return null;
    return (
        <div className={[styles.media, className].filter(Boolean).join(' ')}>
            <img
                src={image.src}
                alt={image.alt}
                decoding="async"
                style={{ objectPosition: `${image.focal.x * 100}% ${image.focal.y * 100}%` }}
            />
        </div>
    );
}
